<div
    [matTooltip]="toolTipText"
    matTooltipPosition="below">
    @if (mode != MenuButtonMode.TextOnly && mode != MenuButtonMode.IconOnly) {
        <lib-button
            #baseButton
            tabindex="0"
            [size]="size"
            [kind]="kind"
            [ariaLabel]="ariaLabel"
            [role]="role"
            [truncate]="truncate"
            [active]="active"
            [disabled]="disabled"
            [prefixIcon]="prefixIcon"
            [suffixIcon]="suffixIcon"
            [iconOnly]="iconOnly"
            [stopPropagation]="stopPropagation"
            (clicked)="OpenMenu($event)"
            (keydown.enter)="OpenMenuFromEnter()"
            (menuClosed)="MenuClosed()"
            [menuTrigger]="optionsMenu"
            [badgeText]="badgeText"
            class="scss-button-tabref"
            [ngClass]="{ hiddenMenu: disabled }"
            target="_blank"
            [qaTag]="qaTag ? qaTag + '-base-button' : ''"
            [stretch]="stretch">
            <ng-container profile *ngTemplateOutlet="profileTemplate"></ng-container>
            <ng-container
                *ngTemplateOutlet="labelTemplate"
                label></ng-container>
        </lib-button>
    }

    @if (mode == MenuButtonMode.TextOnly) {
        <button
            class="remove-default-button-style"
            [attr.aria-label]="ariaLabel || null"
            [matMenuTriggerFor]="optionsMenu"
            #optionsMenuTrigger="matMenuTrigger">
            <ng-container *ngTemplateOutlet="buttonContentTemplate"></ng-container>
        </button>
    }

    @if (mode === MenuButtonMode.IconOnly) {
        <lib-icon-button
            #baseButton
            [icon]="prefixIcon!"
            [disabled]="disabled"
            [size]="size"
            [active]="active"
            [kind]="kind"
            [ariaLabel]="ariaLabel"
            [qaTag]="qaTag ? qaTag + '-icon-button' : ''"
            [menuTrigger]="optionsMenu"
            [ngClass]="{ hiddenMenu: disabled }"
            [badgeText]="badgeText"
            target="_blank"
            (menuClosed)="MenuClosed()"
            (clicked)="OpenMenu()"></lib-icon-button>
    }
</div>

<mat-menu
    #optionsMenu="matMenu"
    yPosition="below"
    [xPosition]="xPosition"
    [overlapTrigger]="false"
    backdropClass="mat-menu-custom-backdrop"
    [class]="customClass"
    tabindex="0">
    @switch (mode) {
        @case (MenuButtonMode.Custom) {
            <ng-container *ngTemplateOutlet="menuContent"></ng-container>
        }

        @default {
            @for (item of menuItemComponents; track item) {
                <div
                    class="v3"
                    [attr.data-sb-qa]="item.qaTag">
                    @if (item.menuDivider === MenuDivider.Above) {
                        <mat-divider class="pb-2 mt-2 mb-0"></mat-divider>
                    }
                    <div class="ps-3 menu-item-header typography-body-medium-strong">
                        <ng-container *ngTemplateOutlet="item.menuItemHeader"></ng-container>
                    </div>

                    @if (!item.hasSubOptions && !item.urlLink) {
                        <button
                            [matTooltip]="item.toolTipText"
                            matTooltipPosition="after"
                            [ngClass]="{ 'disable-menu-item': item.disabled, 'menu-item-default': !item.hint, 'menu-item-with-hint': item.hint }"
                            mat-menu-item
                            (click)="MenuItemClicked(item, $event)">
                            <ng-container *ngTemplateOutlet="menuItem; context: { $implicit: item }"></ng-container>
                        </button>
                    }

                    @if (!item.hasSubOptions && item.urlLink) {
                        <a
                            class="link-menu-item"
                            [matTooltip]="item.toolTipText"
                            matTooltipPosition="after"
                            [ngClass]="{ 'disable-menu-item': item.disabled, 'menu-item-default': !item.hint, 'menu-item-with-hint': item.hint }"
                            mat-menu-item
                            [href]="item.urlLink"
                            routerLinkActive="active"
                            target="_blank"
                            (click)="MenuItemClicked(item, $event)"
                            onclick="return false;">
                            <ng-container *ngTemplateOutlet="menuItem; context: { $implicit: item }"></ng-container>
                        </a>
                    }

                    @if (item.hasSubOptions) {
                        <button
                            [matMenuTriggerFor]="item.hasSubOptions ? optionsSubMenu : null"
                            [matTooltip]="item.toolTipText"
                            matTooltipPosition="after"
                            [ngClass]="{ 'disable-menu-item': item.disabled, 'menu-item-default': !item.hint, 'menu-item-with-hint': item.hint }"
                            mat-menu-item
                            (menuOpened)="OpenMenuItem(item)"
                            (click)="MenuItemClicked(item, $event)">
                            <ng-container *ngTemplateOutlet="menuItem; context: { $implicit: item }"></ng-container>
                        </button>
                    }

                    @if (item.menuDivider === MenuDivider.Below) {
                        <mat-divider class="pt-2 mt-2 mb-0"></mat-divider>
                    }
                </div>
            }
        }
    }
</mat-menu>

<mat-menu #optionsSubMenu="matMenu">
    @for (subMenuItem of subMenuItems; track subMenuItem) {
        <div 
            [attr.data-sb-qa]="subMenuItem.qaTag"
            class="v3">
            <ng-container *ngTemplateOutlet="subMenuItem.menuItemHeader"></ng-container>
            @if (subMenuItem.menuDivider === MenuDivider.Above) {
                <mat-divider class="pb-2 mt-2 mb-0"></mat-divider>
            }
            <button
                [matTooltip]="subMenuItem.toolTipText"
                matTooltipPosition="after"
                [ngClass]="{ 'disable-menu-item': subMenuItem.disabled, 'menu-item-default': !subMenuItem.hint, 'menu-item-with-hint': subMenuItem.hint }"
                mat-menu-item
                (click)="MenuItemClicked(subMenuItem, $event)">
                <ng-container *ngTemplateOutlet="menuItem; context: { $implicit: subMenuItem }"></ng-container>
            </button>
            @if (subMenuItem.menuDivider === MenuDivider.Below) {
                <mat-divider class="pt-2 mt-2 mb-0"></mat-divider>
            }
        </div>
    }
</mat-menu>

<ng-template #labelTemplate>
    @if (!iconOnly) {
        <ng-content select="[label]"></ng-content>
    }
</ng-template>

<ng-template #profileTemplate>
    <ng-content  select="[profile]"></ng-content>
    </ng-template>

<ng-template
    #menuItem
    let-item>
    @if (item.label) {
        <div
            class="d-flex align-items-center h-100 my-auto"
            [ngClass]="{ 'menu-item-under-group': item.hasGroupHeader }">
            @if (item.prefixIcon) {
                <lib-icon
                    [icon]="item.prefixIcon"
                    [size]="IconSize.ExtraSmall"
                    [visible]="item.prefixIconVisible"
                    class="pe-2"></lib-icon>
            }
            <div>
                <p class="typography-input">{{ item.label }}</p>
                @if (item.hint) {
                    <small class="sb-panel-supporting-text">{{ item.hint }}</small>
                }
            </div>
            @if (item.suffixIcon) {
                <lib-icon
                    [icon]="item.suffixIcon"
                    [size]="IconSize.ExtraSmall"
                    [visible]="item.suffixIconVisible"
                    class="ps-2"></lib-icon>
            }
        </div>
    } @else {
        <div
            class="d-flex align-items-center h-100 my-auto"
            [ngClass]="{ 'menu-item-under-group': item.hasGroupHeader }">
            <ng-container *ngTemplateOutlet="item.menuItemContent"></ng-container>
        </div>
    }
</ng-template>
